module.exports = __webpack_public_path__ + "static/media/house-signal.e3a1dcb6.svg";